<script>
  import { onMount } from 'svelte'
  import { update_slot } from 'svelte/internal'

  onMount(() => {
    console.log('COM Mounted')
    console.log(window.openMajors)
    majors = window.openMajors
  })

  let files
  let majors = {}
  let firstName
  let middleName
  let lastName
  let newMajor
  let oldMajor = '';
  let bruinID = ''
  let birthDate
  let address1 = ''
  let address2 = ''
  let city
  let state
  let zip
  let phone
  let email
  let currentGPA
  let currentUnits
  let errBruinID = false
  let submitted = false
  let msg = ''
  let err = ''
  $: {
    if (bruinID.length > 0 && bruinID.length != 9) {
      errBruinID = true
    } else {
      errBruinID = false
    }
  }

  function handleSubmit(e) {
    e.preventDefault()
    console.log('submitting form')
    if (!errBruinID && bruinID.length == 9) {
      var form = document.getElementById('frmChangeOfMajor')
      const formData = new FormData(form)

      for (const [key, value] of formData) {
        console.log(`${key}: ${value}\n`)
      }
      fetch('echo.php', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          console.log('Success:', result)
          msg = result
          if (result.error) {
            submitted = false
            err = result.error
            console.log(err)
          } else {
            submitted = true
          }
        })
        .catch((error) => {
          console.error('Error:', error)
        })
    }
  }
</script>

<style>
  .error {
    color: red;
    font-weight: bold;
  }
</style>

{#if !submitted}
  {#if err}
    <div class="error alert">
      {#each Object.keys(err) as errKey}
        <div>{err[errKey]}</div>
      {/each}
    </div>
  {/if}
  <form
    action="echo.php"
    id="frmChangeOfMajor"
    method="post"
    enctype="multipart/form-data"
    on:submit={handleSubmit}>
    <fieldset>
      <legend>Change of Major</legend>
      <div class="row">
        <div class="large-4 columns">
          <label for="firstName">First Name</label>
          <input
            name="firstName"
            type="text"
            placeholder="First Name (Given Name)"
            bind:value={firstName}
            required="required" />

        </div>
        <div class="large-4 columns">
          <label for="middleName">Middle Name</label>
          <input
            name="middleName"
            type="text"
            placeholder="Middle Name"
            bind:value={middleName} />

        </div>
        <div class="large-4 columns">
          <label for="lastName">Last Name</label>
          <input
            name="lastName"
            type="text"
            placeholder="Last Name (Surname)"
            bind:value={lastName}
            required="required" />

        </div>
      </div>
      <div class="row">

        <div class="small-3 columns">
          <div class="row collapse">
            <label for="major">Current Major</label>
            <div class="small-12 columns">
              <input
                type="text"
                name="oldmajor"
                required="required"
                bind:value={oldMajor} />

            </div>

          </div>
        </div>

        <div class="small-3 columns">
          <div class="row collapse">
            <label for="major">Major You Want To Be</label>
            <div class="small-12 columns">
              <select
                id="major"
                name="major"
                required="required"
                bind:value={newMajor}>
                <option value="">--SELECT MAJOR--</option>
                {#each Object.keys(majors) as major}
                  <option value={major}>{majors[major]}</option>
                {/each}
              </select>

            </div>

          </div>
        </div>
        <div class="small-3 columns left-align">
          <label for="bruinID">UCLA Student ID</label>
          <input
            name="bruinID"
            type="text"
            placeholder="BruinID"
            bind:value={bruinID}
            required="required" />

          {#if errBruinID == true}
            <div class="error alert">UCLA student ID is 9 characters.</div>
          {/if}
        </div>
        <div class="small-3 columns left-align">
          <label for="birthDate">Birth Date</label>
          <input
            name="birthDate"
            type="date"
            placeholder="YEAR/Month/Day"
            bind:value={birthDate}
            required="required" />

        </div>
      </div>
      <div class="row">
        <div class="large-12 columns">
          <label for="address1">Address Line 1</label>
          <input
            name="address1"
            type="text"
            placeholder="Address Line 1"
            bind:value={address1}
            required="required" />

        </div>
        <div class="large-12 columns">
          <label for="address2">Address Line 2</label>
          <input
            name="address2"
            type="text"
            placeholder="Address Line 2"
            bind:value={address2} />

        </div>
      </div>
      <div class="row">
        <div class="large-4 columns">
          <label for="city">City</label>
          <input
            name="city"
            type="text"
            placeholder="City"
            bind:value={city}
            required="required" />

        </div>
        <div class="large-4 columns">
          <label for="state">State</label>
          <select name="state" bind:value={state} required="required">
            <option value="AL">Alabama</option>
            <option value="AK">Alaska</option>
            <option value="AZ">Arizona</option>
            <option value="AR">Arkansas</option>
            <option value="CA">California</option>
            <option value="CO">Colorado</option>
            <option value="CT">Connecticut</option>
            <option value="DE">Delaware</option>
            <option value="DC">District Of Columbia</option>
            <option value="FL">Florida</option>
            <option value="GA">Georgia</option>
            <option value="HI">Hawaii</option>
            <option value="ID">Idaho</option>
            <option value="IL">Illinois</option>
            <option value="IN">Indiana</option>
            <option value="IA">Iowa</option>
            <option value="KS">Kansas</option>
            <option value="KY">Kentucky</option>
            <option value="LA">Louisiana</option>
            <option value="ME">Maine</option>
            <option value="MD">Maryland</option>
            <option value="MA">Massachusetts</option>
            <option value="MI">Michigan</option>
            <option value="MN">Minnesota</option>
            <option value="MS">Mississippi</option>
            <option value="MO">Missouri</option>
            <option value="MT">Montana</option>
            <option value="NE">Nebraska</option>
            <option value="NV">Nevada</option>
            <option value="NH">New Hampshire</option>
            <option value="NJ">New Jersey</option>
            <option value="NM">New Mexico</option>
            <option value="NY">New York</option>
            <option value="NC">North Carolina</option>
            <option value="ND">North Dakota</option>
            <option value="OH">Ohio</option>
            <option value="OK">Oklahoma</option>
            <option value="OR">Oregon</option>
            <option value="PA">Pennsylvania</option>
            <option value="RI">Rhode Island</option>
            <option value="SC">South Carolina</option>
            <option value="SD">South Dakota</option>
            <option value="TN">Tennessee</option>
            <option value="TX">Texas</option>
            <option value="UT">Utah</option>
            <option value="VT">Vermont</option>
            <option value="VA">Virginia</option>
            <option value="WA">Washington</option>
            <option value="WV">West Virginia</option>
            <option value="WI">Wisconsin</option>
            <option value="WY">Wyoming</option>
          </select>

        </div>
        <div class="large-4 columns">
          <label for="zip">Zipcode</label>
          <input
            name="zip"
            type="text"
            placeholder="Postal Code"
            bind:value={zip}
            required="required" />

        </div>
        <div class="large-12 columns">
          <label for="phone">Phone Number</label>
          <input
            name="phone"
            type="text"
            placeholder="phone number"
            bind:value={phone}
            required="required" />

        </div>
        <div class="large-12 columns">
          <label for="email">Email Address</label>
          <input
            name="email"
            type="email"
            placeholder="name@ucla.edu"
            required="required"
            bind:value={email} />

        </div>
      </div>
      <div class="row">
        <div class="large-12 columns">
          <label for="file">PDF of Petition</label>
          <input
            type="file"
            name="file"
            id="file"
            bind:value={files}
            required="required"
            accept="application/pdf" />

        </div>
      </div>
      <div class="row">
        <div class="large-4 columns">
          <label for="currentGPA">Current UCLA GPA</label>
          <input
            name="currentGPA"
            type="text"
            placeholder="Current UCLA GPA"
            bind:value={currentGPA}
            required="required" />

        </div>
        <div class="small-4 columns">
          <label for="currentUnits">TOTAL UCLA Units earned</label>
          <input
            name="currentUnits"
            type="text"
            placeholder="Current Units"
            bind:value={currentUnits} />

        </div>
        <div class="large-4 columns" />
      </div>
      <button name="btnSubmit" id="btnSubmit" type="submit" value="Submit">
        Submit
      </button>
    </fieldset>
  </form>
{/if}

{#if submitted == true}
  <fieldset>
    {#if msg.msg == 'success'}
      You will receive an email shortly. You may login immediatly with the
      credentials you have provided.
    {/if}
    {#if msg.msg == 'fail'}
      You may have already submitted a petition. If you feel this is in error
      please contact us.
    {/if}
  </fieldset>
{/if}
